export const commonUtilConstants = {
  ATTACHMENTS_LIST_REQUEST: "ATTACHMENTS_LIST_REQUEST",
  ATTACHMENTS_LIST_SUCCESS: "ATTACHMENTS_LIST_SUCCESS",
  ATTACHMENTS_LIST_FAILURE: "ATTACHMENTS_LIST_FAILURE",
  
  ATTACHMENTS_DELETE_REQUEST: "ATTACHMENTS_DELETE_REQUEST",
  ATTACHMENTS_DELETE_SUCCESS: "ATTACHMENTS_DELETE_SUCCESS",
  ATTACHMENTS_DELETE_FAILURE: "ATTACHMENTS_DELETE_FAILURE",

  UPLOAD_ATTACHMENT_REQUEST: "UPLOAD_ATTACHMENT_REQUEST",
  UPLOAD_ATTACHMENT_SUCCESS: "UPLOAD_ATTACHMENT_SUCCESS",
  UPLOAD_ATTACHMENT_FAILURE: "UPLOAD_ATTACHMENT_FAILURE",

  GET_HTML_DETAILS_REQUEST: "GET_HTML_DETAILS_REQUEST",
  GET_HTML_DETAILS_SUCCESS: "GET_HTML_DETAILS_SUCCESS",
  GET_HTML_DETAILS_FAILURE: "GET_HTML_DETAILS_FAILURE",

  UPDATE_HTML_DETAILS_REQUEST: "UPDATE_HTML_DETAILS_REQUEST",
  UPDATE_HTML_DETAILS_SUCCESS: "UPDATE_HTML_DETAILS_SUCCESS",
  UPDATE_HTML_DETAILS_FAILURE: "UPDATE_HTML_DETAILS_FAILURE",
};
